<template>
    <div class="page-container">
        <!-- 智能产品 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>软件产品</h2>
            </div>
            <div class="smart-wrapper">
                <el-row class="smart-row" :gutter="30">
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" :xxl="6" class="smart-item" v-for="item in smart"
                        :key="item.title">
                        <div class="smart-card">
                            <div class="smart-image-container">
                                <img :src="item.image" class="smart-image" :alt="item.title">
                            </div>
                            <div class="smart-text-content">
                                <h3 class="smart-title">{{ item.title }}</h3>
                                <el-button type="text" class="smart-button" @click="goToTypicalcase(item.path)">
                                    了解详情
                                </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainSoftware',
    data() {
        return {
            services: [
                {
                    title: '智能芯片',
                    description: '自主研发的高性能芯片，支持多种农业场景的智能化控制和数据处理',
                    image: require('@/assets/images/MainHardware/znxp.png')
                },
                {
                    title: '云端管理',
                    description: '基于云计算的智能管理平台，实现农业生产全过程的数字化监控与决策',
                    image: require('@/assets/images/MainHardware/ydgl.png')
                },
                {
                    title: '数据安全',
                    description: '采用多重加密技术，确保农业生产数据的安全性与可靠性',
                    image: require('@/assets/images/MainHardware/sjaq.png')
                }
            ],
            smart: [
                {
                    title: '网纹瓜全产业链数智管理平台',
                    description: '人在家中睡，一键起棉被！',
                    image: require('@/assets/images/Mainsoftware/wwg.png'),
                    path: '/wangwenguaDetails'

                },
                {
                    title: '智能灌溉模型决策系统',
                    description: '人在家中睡，一键起棉被！',
                    image: require('@/assets/images/Mainsoftware/znggmx.png'),
                    path: '/zhinengguangaiDetails'
                },
                {
                    title: '数字农业智能驾驶舱',
                    description: '温控数据全知晓    智能放风护苗好',
                    image: require('@/assets/images/Mainsoftware/znjsc.png'),
                    path: '/shuzinongyeDetails'
                },
                {
                    title: '数字农业园区大数据分析平台',
                    description: '省水省肥又省力 增产增收不是梦',
                    image: require('@/assets/images/Mainsoftware/sznyyq.png'),
                    path: '/dashujuDetails'
                },

            ]
        }
    },
    methods: {
        goToTypicalcase(path) {
            this.$router.push(path);
        }
    }

}
</script>

<style scoped>
.page-container {
    width: 100%;
    background-color: rgba(216, 216, 216, 0.2);
    overflow-x: hidden;
}



.smart-container {
    width: 100%;
    max-width: 1920px;
    padding: 10px 20px 60px;
    box-sizing: border-box;
    margin: 0 auto;
}

.smart-wrapper {
    width: 100%;
    margin: 0 auto;
}

.smart-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
    margin: 0 !important;
}

.smart-item {
    box-sizing: border-box;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
}

.smart-card {
    background-color: #ffffff;
    border-radius: 0.5rem;
    padding: 24px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.smart-card:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.smart-image-container {
    width: 100%;
    height: 280px;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.smart-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.smart-text-content {
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.smart-title {
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
    font-weight: 550;
    line-height: 28px;
    color: #111827;
    margin-top: 0;
}

.smart-button {
    display: flex;
    align-items: center;
    white-space: nowrap;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    cursor: pointer;
    transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);
    margin-top: auto;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    width: 112px;
    height: 40px;
    background-color: #2563EB;
    justify-content: center;
    border-radius: 4px;
}

.smart-button:hover {
    color: #1d4ed8;
    background-color: transparent;
    border: 1px solid #2563EB;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {
    .matrix-container {
        padding: 40px 15px;
    }

    .matrix-header {
        margin-bottom: 40px;
    }

    .matrix-header h2 {
        font-size: 24px;
        line-height: 32px;
    }

    .matrix-header p {
        font-size: 16px;
        line-height: 22px;
    }

    .matrix-card {
        padding: 16px;
    }

    .matrix-image {
        max-width: 50px;
        max-height: 50px;
    }

    .matrix-title {
        font-size: 16px;
        line-height: 24px;
    }

    .matrix-description {
        font-size: 14px;
        line-height: 20px;
    }

    .smart-container {
        padding: 10px 15px 40px;
    }

    .smart-image-container {
        height: 200px;
    }

    .smart-title {
        font-size: 16px;
        line-height: 24px;
    }

    .smart-button {
        width: 100px;
        height: 36px;
        font-size: 14px;
    }
}

/* 平板设备样式 (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
    .matrix-header h2 {
        font-size: 28px;
        line-height: 34px;
    }

    .matrix-header p {
        font-size: 17px;
        line-height: 23px;
    }

    .smart-image-container {
        height: 240px;
    }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
    .matrix-container {
        max-width: 2400px;
        padding: 80px 30px;
    }

    .matrix-header {
        margin-bottom: 80px;
    }

    .matrix-header h2 {
        font-size: 42px;
        line-height: 48px;
    }

    .matrix-header p {
        font-size: 24px;
        line-height: 32px;
    }

    .matrix-card {
        padding: 32px;
    }

    .matrix-image {
        max-width: 80px;
        max-height: 80px;
    }

    .matrix-title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 16px;
    }

    .matrix-description {
        font-size: 20px;
        line-height: 28px;
    }

    .smart-container {
        max-width: 2400px;
        padding: 20px 30px 80px;
    }

    .smart-row {
        gutter: 40;
    }

    .smart-card {
        padding: 32px;
    }

    .smart-image-container {
        height: 360px;
    }

    .smart-title {
        font-size: 24px;
        line-height: 32px;
    }

    .smart-button {
        width: 130px;
        height: 48px;
        font-size: 18px;
    }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
    .matrix-container {
        max-width: 3200px;
        padding: 100px 40px;
    }

    .matrix-header {
        margin-bottom: 100px;
    }

    .matrix-header h2 {
        font-size: 52px;
        line-height: 60px;
    }

    .matrix-header p {
        font-size: 30px;
        line-height: 40px;
    }

    .matrix-card {
        padding: 40px;
    }

    .matrix-image {
        max-width: 100px;
        max-height: 100px;
    }

    .matrix-title {
        font-size: 30px;
        line-height: 40px;
        margin-bottom: 20px;
    }

    .matrix-description {
        font-size: 24px;
        line-height: 34px;
    }

    .smart-container {
        max-width: 3200px;
        padding: 20px 40px 100px;
    }

    .smart-row {
        gutter: 50;
    }

    .smart-card {
        padding: 40px;
    }

    .smart-image-container {
        height: 450px;
    }

    .smart-title {
        font-size: 30px;
        line-height: 40px;
    }

    .smart-button {
        width: 150px;
        height: 56px;
        font-size: 22px;
    }
}
</style>